import jsCookie from "js-cookie";

export const getCookie = async (name: string) => {
  if (typeof window === "undefined") {
    // const { cookies } = require("next/headers");
    const { cookies } = await import("next/headers");
    const cookieStore = cookies();
    return cookieStore.get(name)?.value || null;
  } else {
    return jsCookie.get(name);
  }
};

export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes | undefined
) => {
  if (typeof window === "undefined") {
    throw new Error(
      "Can't set cookies server-side using js-cookie. Use appropriate server-side method."
    );
  } else {
    jsCookie.set(name, value, options);
  }
};

export const removeCookie = (
  name: string,
  options?: Cookies.CookieAttributes | undefined
) => {
  if (typeof window === "undefined") {
    throw new Error(
      "Can't remove cookies server-side using js-cookie. Use appropriate server-side method."
    );
  } else {
    jsCookie.remove(name, options);
  }
};
